exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-e6913484] .el-input-number .el-input__inner{text-align:left}", ""]);

// exports
